import axios from "axios";
import { IP } from "../index";
// 查询所有订单
export async function selectallorder(data) {
  var resp = await axios.post(`${IP}/admin/organizationOrder/selectByState`, {
    ...data,
  });
  return resp.data;
}

// 删除订单
export async function deleteOrder(id) {
  var resp = await axios.post(`${IP}/admin/organizationOrder/deleteById`, {
    id,
  });
  return resp.data;
}

// 修改订单
export async function updateOrder(data) {
  var resp = await axios.post(`${IP}/admin/organizationOrder/updateResult`, {
    ...data,
  });
  return resp.data;
}

